import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/view/layout'
//登录
import login from '@/view/login'
//短信
import messageList from '@/view/message/messageList'
import autograph from '@/view/message/autographList'
//记录
import msgRecord from '@/view/autograph/msgRecord'
//客户
import customer from '@/view/customer/customerList'
import rechargeMsg from '@/view/customer/rechargeMsg'
//通道
import passagewayMsg from '@/view/passageway/passagewayMsg'
//api文档
import checkMsgCode from '@/view/apidoc/checkMsgCode'
import sendMsg from '@/view/apidoc/sendMsg'
import parameterAtypism from '@/view/apidoc/parameterAtypism'
import sendCode from '@/view/apidoc/sendCode'
Vue.use(Router)

export default new Router({
  routes: [
    { path: '/index', name: '登录', component: login },
    { path: '/maessage', component: Layout, redirect: '/message', name: '短信配置',
      children: [
        { path: '/message', navName: '短信模板', component: messageList },
        { path: '/autograph', navName: '签名', component: autograph },
      ]
    },
    { path: '/msgRecord', component: Layout, redirect: '/msgRecord', name: '短信记录',
        children: [
          { path: '/msgRecord', navName: '短信发送记录', component: msgRecord },
        ]
    },
    { path: '/customer', component: Layout, redirect: '/customer', name: '客户管理',
        children: [
          { path: '/customer', navName: '客户列表', component: customer },
          { path: '/rechargeMsg', navName: '充值记录', component: rechargeMsg }
        ]
    },
    { path: '/passagewayMsg', component: Layout, redirect: '/passagewayMsg', name: '通道管理',
        children: [
          { path: '/passagewayMsg', navName: '短信通道', component: passagewayMsg },
        ]
    },
    { path: '/checkMsgCode', component: Layout, redirect: '/checkMsgCode', name: 'api文档',
        children: [
          { path: '/checkMsgCode', navName: '校验短信验证码', component: checkMsgCode },
          { path: '/sendMsg', navName: '发送短信(参数一致)', component: sendMsg },
          { path: '/parameterAtypism', navName: '发送短信(参数不一致)', component: parameterAtypism },
          { path: '/sendCode', navName: '发送验证码', component: sendCode },
        ]
    },
    {
      path: '*',
      redirect: '/index'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js